
import * as API from './api';
import * as actionTypes from './actiontypes';
import { log, showMessage} from '../../config/utils';


export const updatePageState = (payload, path) => {
  return {
    type: actionTypes.UPDATE_PAGE_STATE,
    payload,
    path
  };
};

export const startPageLoading = payload => {
  return {
    type: actionTypes.PAGE_LOADING,
    payload
  };
};

export const stopPageLoading = () => {
  return {
    type: actionTypes.PAGE_LOADED
  };
};

export const pageChanged = (current_page, current_sider_module) => {
  return {
    type: actionTypes.PAGE_CHANGED,
    payload: {
      current_page,
      current_sider_module
    }
  };
};

export const trainYourBot = () => {
  return dispatch => {
    dispatch(updatePageState(true, "loaders.bot_training"));
    API.trainYourBot({}, (error, response) => {
      dispatch(updatePageState(false, "loaders.bot_training"));
      if (!error) {
        showMessage(
          "loading",
          response && response.message
            ? response.message
            : "bot training in progress."
        );
      }
    });
  };
};

export const publishYourBot = () => {
  return dispatch => {
    dispatch(updatePageState(true, "loaders.bot_publishing"));
    API.publishYourBot({}, (error, response) => {
      dispatch(updatePageState(false, "loaders.bot_publishing"));
      if (!error) {
        showMessage(
          "loading",
          response && response.message
            ? response.message
            : "bot publishing in progress."
        );
      }
    });
  };
};

export const whatsAppFileUpload = data => dispatch => {
  dispatch(updatePageState(true, "loaders.wa_file_uploading"));
  API.whatsAppFileUpload(data, (error, response) => {
    dispatch(updatePageState(false, "loaders.wa_file_uploading"));
    if (!error)
      showMessage(
        "success",
        response && response.message
          ? response.message
          : "File uploaded successfully."
      );
  });
};

export const updateTagsInConversations = (data, callback) => dispatch => {
  dispatch(startPageLoading("Updating"));
  API.updateTagsInConversations(data, (error, response) => {
    log("response", response);
    dispatch(stopPageLoading());
    if (
      !error &&
      response &&
      response.data &&
      response.data.sessionId &&
      response.data.selectedTags
    ) {
      dispatch({
        type: actionTypes.GLOBAL_UPDATE_PROFILE_DATA_IN_CONVERSATIONS,
        payload: {
          sessionId: response.data.sessionId,
          psid: response.data.psid,
          changed_value: {
            selectedTags: response.data.selectedTags
          }
        }
      });
      if (callback) callback();
    }
  });
};

const pageLoaded = dispatch => {
  dispatch({
    type: actionTypes.PAGE_LOADED
  });
};

export const voteChatlog = data => {
  return dispatch => {
    dispatch({
      type: actionTypes.PAGE_LOADING,
      payload: `${data.vote} in progress`
    });
    API.voteChatlog(data, (error, response) => {
      pageLoaded(dispatch);
      if (!error && response && response.data) {
        dispatch({
          type: actionTypes.GLOBAL_UPDATE_MESSAGE,
          payload: response.data
        });
        showMessage(
          "success",
          response && response.message
            ? response.message
            : `${data.vote} success.`
        );
      }
    });
  };
};




// WEBPACK FOOTER //
// ./src/data/redux/page_details/actions.js